export default "__VITE_ASSET__C4dV_KPb__";